import { createComponent } from '@mtfe/sweet';
import {
    eventBus,
    common,
    createDeepLink,
    createObserve,
} from '@mtfe/sweet-utils';
import {
    WelfareCard,
    componentUtils,
    Draw,
    GoodsCounponList,
} from '@mtfe/sweet-components';

import tpl from './dom.html';
import style from './style.less';
import WaimaiDrawBody from '../WaimaiDrawBody/script';
import InnerPoi from '../common/InnerPoi/script';

import { fetchAllCoupon, fetchOneRedBag } from '../../utils/fetchData';
import { renderPoiInfoG } from '../../utils/renderPoi';
import { useAutoLogin } from '../../utils/index';
import { COUPON_STATUS } from '../../constants/index';
import http from '../../service';
import store from '../../store/index';
import { filterRedBagListWithSku } from '../../utils/filter';

const { storeCommon } = store;
const { debounceByPromise, createUniqueId } = common;
const { getOnClickEventName } = componentUtils;
const deepLink = createDeepLink();

const SkuCouponListV2Ready = (skuCouponListObj) => {
    eventBus.$on('SkuCouponListV2Ready', () => {
        const { skuCouponList } = skuCouponListObj.propsCache;
        const couponDomList = Array.from(
            document.querySelectorAll(
                `#${skuCouponListObj.sgSkuCouponModuleID} [coupon-monitor-index]`,
            ),
        );
        const observeCb = async (err, item) => {
            if (err) {
                return;
            }
            try {
                const currentIndex = item.target.getAttribute(
                    'coupon-monitor-index',
                );
                const { impMonitorUrl } = skuCouponList[currentIndex];
                await http.gMonitorApi(impMonitorUrl);
            } catch (error) {
                console.error('曝光失败', error);
            }
        };
        if (couponDomList.length) {
            createObserve(observeCb, couponDomList);
        }
    });
};

const SkuCouponListV2 = (props = {}) => {
    const { targetStore, couponKey, welfareIndex } = props;
    const { recallBizId, discountData } = targetStore;
    const { redBagList, giftValue } = discountData;
    const SkuCouponListID = createUniqueId();

    const redBagListWithSku = filterRedBagListWithSku(redBagList);

    if (!redBagListWithSku.length) {
        return '';
    }
    redBagListWithSku.forEach((poiInfo) => {
        const {
            poiData,
            coupon_amount: couponAmount,
            order_amount_limit: orderAmountLimit,
        } = poiInfo.giftInfo;

        const poiListDom = InnerPoi({ poiData, renderFunc: renderPoiInfoG });
        poiInfo.draw = new Draw(
            WaimaiDrawBody({
                value: couponAmount / 100,
                threshold: orderAmountLimit / 100,
                poiListDom,
                isShangouModule: couponKey === 'Shangou',
            }),
        );
    });

    const onClickRedBagBtnHandler = debounceByPromise(
        useAutoLogin(async (poiInfo, goodsIndex) => {
            const { giftInfo, draw, skuInfoList } = poiInfo;
            const { gift_id: giftId } = giftInfo;
            const canReceive = giftInfo.status === COUPON_STATUS.STATUS_NEW;
            if (canReceive) {
                try {
                    await fetchOneRedBag(poiInfo, recallBizId);
                } catch (error) {
                    console.error(error);
                }
            } else {
                if (goodsIndex >= 0 && skuInfoList && skuInfoList[goodsIndex]) {
                    const { skuDpUrl, skuLpUrl, clickMonitorUrl } =
                        skuInfoList[goodsIndex];
                    // 跳转至菜品
                    deepLink.gotoDp(skuDpUrl, skuLpUrl, () => {
                        http.actGeClkM(clickMonitorUrl);
                    });
                } else if (draw) {
                    const {
                        dom_sg_cps_unbind_coupon_poi: domSgLargeRedBagPoi,
                        dom_sg_cps_unbind_coupon_sku: domSgSkuCoupon,
                    } = storeCommon.structInfo.struct;
                    draw.onOpenDraw(() => {
                        let nameRecallBizId = recallBizId;
                        if (recallBizId === domSgSkuCoupon.recallBizId) {
                            nameRecallBizId = domSgLargeRedBagPoi.recallBizId;
                        }
                        const onClickEventName = getOnClickEventName(
                            nameRecallBizId,
                            giftId,
                        );
                        eventBus.$emit(onClickEventName);
                    });
                }
            }
        }),
        500,
        true,
    );
    const onClickRedBagReceiveAllHandler = debounceByPromise(
        useAutoLogin(async () => {
            try {
                await fetchAllCoupon(redBagList, recallBizId);
                // eslint-disable-next-line
                skuCouponListObj.render();
                // 闪购tab气泡提示
            } catch (error) {
                console.error(error);
            }
        }),
        500,
        true,
    );
    const skuCouponListObj = new GoodsCounponList({
        skuCouponList: redBagListWithSku,
        onCounponAndGooodsClick: onClickRedBagBtnHandler,
        onClickReceiveAll: onClickRedBagReceiveAllHandler,
    });
    const data = {
        sgSkuCouponListDom: WelfareCard({
            welfareIndex,
            title: `${giftValue / 100}元商品大额券`,
            innerComponent: skuCouponListObj.getComponent(),
        }),
        SkuCouponListID,
    };
    const events = {};
    SkuCouponListV2Ready(skuCouponListObj);
    return createComponent(tpl, { data, style }, events);
};
export default SkuCouponListV2;
